// extracted by mini-css-extract-plugin
export var images = "PhotoReel-module--images--b4b1a";
export var photoReel = "PhotoReel-module--photo-reel--85bc3";